import React from 'react';

const TechNote: React.FC = () => (
  <section className="max-w-7xl mx-auto px-6 mb-16">
    <div className="bg-slate-100 rounded-2xl p-8 md:p-10 grid grid-cols-1 md:grid-cols-[auto_1fr] gap-6 items-start">
      <div className="text-3xl bg-white p-3 rounded-xl inline-block">🔧</div>
      <div>
        <h3 className="font-mono text-sm uppercase tracking-wider text-green-700 mb-2">
          Technical Details
        </h3>
        <p className="text-slate-600 leading-relaxed">
          Megadish creates a private network using Network Address Translation (NAT). Unlike a WiFi 
          range extender which repeats the same network, your devices never join the public network — 
          they connect only to Megadish. The ESP32 microcontroller has no operating system, making it 
          inherently more secure than software solutions. No data is collected or transmitted.
        </p>
      </div>
    </div>
  </section>
);

export default TechNote;
